/**
 * localStorage-backed cache for Free Time activity suggestions.
 *
 * Mirrors mobile/src/utils/freeTimeSuggestionsCache.js — same key shape
 * and TTL, just localStorage instead of AsyncStorage. See the mobile
 * file for the full rationale.
 */

const PREFIX = 'freeTimeSugg:v1:';
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

function safeKey(s) {
  return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').slice(0, 40);
}

export function freeTimeSuggestionsCacheKey({ itineraryId, dayIndex, beforeTime, afterTime, city }) {
  if (!beforeTime || !afterTime) return null;
  const idPart = itineraryId ? safeKey(itineraryId) : 'unsaved';
  const dayPart = String(dayIndex ?? '0');
  return `${PREFIX}${idPart}:${dayPart}:${beforeTime}:${afterTime}:${safeKey(city)}`;
}

export function readFreeTimeSuggestions(args) {
  try {
    const key = freeTimeSuggestionsCacheKey(args);
    if (!key) return null;
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (!parsed.expiresAt || parsed.expiresAt < Date.now()) {
      try { localStorage.removeItem(key); } catch {}
      return null;
    }
    return Array.isArray(parsed.suggestions) ? parsed.suggestions : null;
  } catch {
    return null;
  }
}

export function writeFreeTimeSuggestions(args, suggestions) {
  try {
    if (!Array.isArray(suggestions) || suggestions.length === 0) return;
    const key = freeTimeSuggestionsCacheKey(args);
    if (!key) return;
    localStorage.setItem(
      key,
      JSON.stringify({ suggestions, expiresAt: Date.now() + TTL_MS }),
    );
  } catch {
    // localStorage quota or unavailable — ignore. Worst case is the user
    // pays the LLM call again on next tap.
  }
}
